<div class="card-container-container">
  <div class="card-container">
    <mat-card>
      <mat-card-content>
        @if (userReport) {
        <div class="fx-layout-row">
          <div class="fx-fill">
              @if (reportForm.controls.activateReports.value) {
                <div class="m-t-10 m-b-10 field-container fx-layout-col fx-justify-space-between fx-align-baseline fx-gap-20">
                  @if (userReport?.lastSendDate.isValid()) {
                    <div class="fx-layout-row fx-justify-start fx-align-baseline">
                      <div>
                        {{ 'LABEL.LAST_SENT_REPORT_DATE' | translate }} {{ formatDate(userReport?.lastSendDate) }}
                      </div>
                      <div class="m-l-20">
                        <button (click)="sendLastReport()" id="send_last_report"
                                mat-stroked-button>{{ 'LABEL.REFER' | translate }}
                        </button>
                      </div>
                    </div>
                  }
                  @if (sendDate) {
                    <div class="m-l-20">
                      {{ 'LABEL.NEXT_REPORT' | translate }} {{ formatDate(sendDate) }}
                    </div>
                  }
                </div>
              } @else {
                <div class="m-l-20 m-t-10 m-b-10">
                  {{ 'LABEL.NO_REPORT_SCHEDULED' | translate }}
                </div>
              }

              <form [formGroup]="reportForm">
                <section>
                  <h3 class="report-section-title">{{ 'LABEL.GENERAL_SETTINGS' | translate }}</h3>
                  <div class="report-field-container">
                    <div class="fx-layout-row fx-gap-10-percent m-b-10">
                      <mat-label>{{ 'LABEL.GET_REPORT' | translate }}</mat-label>
                      <mat-slide-toggle formControlName="activateReports"
                                        [checked]="reportForm.controls.activateReports.value"></mat-slide-toggle>
                    </div>
                    @if (reportForm.controls.activateReports.value) {
                      <div>
                        <div class="m-b-10">{{ 'LABEL.CONFIG_PERIODICITY_REPORT' | translate }}</div>
                        <div class="fx-layout-col fx-gap-10">
                          <div class="fx-layout-row fx-justify-start fx-align-baseline fx-gap-20">
                            <span class="fx-flex-10-percent">{{ 'LABEL.DAYS_WEEK' | translate }}</span>
                            <mat-form-field appearance="outline" class="fx-flex-10-percent">
                              <mat-select formControlName="dayOfWeek" id="dayOfWeek">
                                @for (day of daysOfWeek; track day) {
                                  <mat-option [value]="day">
                                    {{ 'LABEL.DAY_' + day | translate }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                            <span>{{ 'LABEL.AT' | translate }}</span>
                            <mat-form-field appearance="outline" class="fx-flex-10-percent">
                              <mat-select formControlName="hour" id="hour">
                                @for (hour of hours; track hour) {
                                  <mat-option [value]="hour">
                                    {{ hour }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="fx-layout-row fx-justify-start fx-align-baseline fx-gap-20">
                            <span class="fx-flex-10-percent">{{ 'LABEL.PERIODICITY' | translate }}</span>
                            <!-- TODO TTT-4548 replace select with localised TimePicker in Material 19+ -->
                            <mat-form-field appearance="outline" class="fx-flex-15-percent">
                              <mat-select formControlName="periodicity" id="periodicity">
                                @for (periodicity of periodicityWeekList; track periodicity) {
                                  <mat-option [value]="periodicity">
                                    {{ 'LABEL.PERIODICITY_WEEK_' + periodicity | translate }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </section>

                @if (reportForm.controls.activateReports.value) {
                  <section formGroupName="entitiesHistory">
                    <h3 class="report-section-title">{{ 'LABEL.REPORT_CONTENT' | translate }}</h3>
                    <div class="report-field-container">
                      <div>
                        <div>{{ 'LABEL.REPORT_ACTIONS_CONFIG' | translate }}</div>
                        <div>{{ 'LABEL.REPORT_ACTIONS_DESCRIPTIONS' | translate }}</div>
                      </div>
                      <div class="m-t-10 fx-layout-col fx-gap-15">
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>{{ 'LABEL.ASSET' | translate }}</mat-expansion-panel-header>
                          <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                            <mat-label class="fx-flex-20-percent">{{ 'LABEL.ASSET_ADDED' | translate }}</mat-label>
                            <mat-slide-toggle class="fx-flex-20-percent" formControlName="onAssetCreated"
                                              [checked]="reportForm.controls.entitiesHistory.controls.onAssetCreated.value"></mat-slide-toggle>
                          </div>
                          <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                            <mat-label class="fx-flex-20-percent">{{ 'LABEL.ASSET_MODIFIED' | translate }}</mat-label>
                            <mat-slide-toggle class="fx-flex-20-percent" formControlName="onAssetUpdated"
                                              [checked]="reportForm.controls.entitiesHistory.controls.onAssetUpdated.value"></mat-slide-toggle>
                          </div>
                          <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                            <mat-label class="fx-flex-20-percent">{{ 'LABEL.ASSET_DELETED' | translate }}</mat-label>
                            <mat-slide-toggle class="fx-flex-20-percent" formControlName="onAssetDeleted"
                                              [checked]="reportForm.controls.entitiesHistory.controls.onAssetDeleted.value"></mat-slide-toggle>
                          </div>
                        </mat-expansion-panel>
                        @if (accessManager.hasAccess(Permission.VIEW_SPACE)) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>{{ 'LABEL.SPACE' | translate }}</mat-expansion-panel-header>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.SPACE_ADDED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onSpaceCreated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onSpaceCreated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.SPACE_MODIFIED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onSpaceUpdated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onSpaceUpdated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.SPACE_DELETED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onSpaceDeleted"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onSpaceDeleted.value"></mat-slide-toggle>
                            </div>
                          </mat-expansion-panel>
                        }
                        @if (accessManager.hasAccess(Permission.VIEW_DOCUMENT)) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>{{ 'LABEL.DOCUMENT' | translate }}</mat-expansion-panel-header>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.DOCUMENT_ADDED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onDocumentCreated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onDocumentCreated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.DOCUMENT_MODIFIED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onDocumentUpdated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onDocumentUpdated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.DOCUMENT_DELETED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onDocumentDeleted"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onDocumentDeleted.value"></mat-slide-toggle>
                            </div>
                          </mat-expansion-panel>
                        }
                        @if (accessManager.hasAccess(Permission.VIEW_CHECK)) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>{{ 'LABEL.CHECK' | translate }}</mat-expansion-panel-header>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.CHECK_ADDED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onCheckCreated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onCheckCreated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.CHECK_MODIFIED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onCheckUpdated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onCheckUpdated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.CHECK_DELETED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onCheckDeleted"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onCheckDeleted.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.CHECK_EXPIRED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onCheckExpired"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onCheckExpired.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <span>{{ 'LABEL.CHECK_TO_RENEW_IN' | translate }}</span>
                              <mat-form-field appearance="outline" class="fx-flex-10-percent">
                                <mat-select formControlName="checkToRenewInterval" id="checkToRenewInterval">
                                  @for (periodicity of periodicityMonthList; track periodicity) {
                                    <mat-option [value]="periodicity">
                                      {{ periodicity }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                              <mat-form-field appearance="outline" class="fx-flex-25-percent">
                                <mat-select formControlName="checkToRenewUnit" id="checkToRenewUnit">
                                  @for (timeUnit of timeUnits; track timeUnit) {
                                    <mat-option [value]="timeUnit">
                                      {{ 'LABEL.' + timeUnit | uppercase | translate }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="checkRenewalEnabled"
                                                [checked]="reportForm.controls.entitiesHistory.controls.checkRenewalEnabled.value">
                              </mat-slide-toggle>
                            </div>
                            @if (reportForm.controls.entitiesHistory.controls.checkPeriodicityError.value) {
                              <div>
                                <span
                                  class="text-warning">{{ 'LABEL.REPORT_CHECK_TO_RENEW_PERIODICITY_ERROR' | translate }}</span>
                              </div>
                            }
                          </mat-expansion-panel>
                        }
                        @if (accessManager.hasAccess(Permission.VIEW_OCCUPANT)) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>{{ 'LABEL.OCCUPANT' | translate }}</mat-expansion-panel-header>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.OCCUPANT_ADDED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onOccupantCreated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onOccupantCreated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.OCCUPANT_MODIFIED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onOccupantUpdated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onOccupantUpdated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.OCCUPANT_DELETED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onOccupantDeleted"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onOccupantDeleted.value"></mat-slide-toggle>
                            </div>
                          </mat-expansion-panel>
                        }
                        @if (accessManager.hasAccess(Permission.VIEW_OCCUPANT)) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>{{ 'LABEL.LEASE_IN_OCCUPANT' | translate }}</mat-expansion-panel-header>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.LEASE_ADDED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onLeaseCreated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onLeaseCreated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.LEASE_MODIFIED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onLeaseUpdated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onLeaseUpdated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.LEASE_DELETED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onLeaseDeleted"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onLeaseDeleted.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.LEASE_EXPIRED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onLeaseExpired"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onLeaseExpired.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <span>{{ 'LABEL.LEASE_TO_RENEW_IN' | translate }}</span>
                              <mat-form-field appearance="outline" class="fx-flex-10-percent">
                                <mat-select formControlName="leaseToRenewInterval" id="leaseToRenewInterval">
                                  @for (periodicity of periodicityMonthList; track periodicity) {
                                    <mat-option [value]="periodicity">
                                      {{ periodicity }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                              <mat-form-field appearance="outline" class="fx-flex-25-percent">
                                <mat-select formControlName="leaseToRenewUnit" id="leaseToRenewUnit">
                                  @for (timeUnit of timeUnits; track timeUnit) {
                                    <mat-option [value]="timeUnit">
                                      {{ 'LABEL.' + timeUnit | uppercase | translate }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="leaseRenewalEnabled"
                                                [checked]="reportForm.controls.entitiesHistory.controls.leaseRenewalEnabled.value">
                              </mat-slide-toggle>
                            </div>
                            @if (reportForm.controls.entitiesHistory.controls.leasePeriodicityError.value) {
                              <div>
                                <span
                                  class="text-warning">{{ 'LABEL.REPORT_LEASE_TO_RENEW_PERIODICITY_ERROR' | translate }}</span>
                              </div>
                            }
                          </mat-expansion-panel>
                        }
                        @if (accessManager.hasAccess(Permission.VIEW_CONTRACT)) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>{{ 'LABEL.CONTRACT_OF_MAINTENANCE' | translate }}</mat-expansion-panel-header>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.CONTRACT_ADDED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onContractCreated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onContractCreated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.CONTRACT_MODIFIED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onContractUpdated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onContractUpdated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.CONTRACT_DELETED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onContractDeleted"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onContractDeleted.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.CONTRACT_EXPIRED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onContractExpired"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onContractExpired.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <span>{{ 'LABEL.CONTRACT_TO_RENEW_IN' | translate }}</span>
                              <mat-form-field appearance="outline" class="fx-flex-10-percent">
                                <mat-select formControlName="contractToRenewInterval" id="contractToRenewInterval">
                                  @for (periodicity of periodicityMonthList; track periodicity) {
                                    <mat-option [value]="periodicity">
                                      {{ periodicity }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                              <mat-form-field appearance="outline" class="fx-flex-25-percent">
                                <mat-select formControlName="contractToRenewUnit" id="contractToRenewUnit">
                                  @for (timeUnit of timeUnits; track timeUnit) {
                                    <mat-option [value]="timeUnit">
                                      {{ 'LABEL.' + timeUnit | uppercase | translate }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="contractRenewalEnabled"
                                                [checked]="reportForm.controls.entitiesHistory.controls.contractRenewalEnabled.value">
                              </mat-slide-toggle>
                            </div>
                            @if (reportForm.controls.entitiesHistory.controls.contractPeriodicityError.value) {
                              <div>
                                <span
                                  class="text-warning">{{ 'LABEL.REPORT_LEASE_TO_RENEW_PERIODICITY_ERROR' | translate }}</span>
                              </div>
                            }
                          </mat-expansion-panel>
                        }
                        @if (accessManager.hasAccess(Permission.VIEW_WORK)) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>{{ 'LABEL.WORK' | translate }}</mat-expansion-panel-header>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.WORK_ADDED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onWorkCreated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onWorkCreated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.WORK_MODIFIED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onWorkUpdated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onWorkUpdated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.WORK_DELETED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onWorkDeleted"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onWorkDeleted.value"></mat-slide-toggle>
                            </div>
                          </mat-expansion-panel>
                        }
                        @if (accessManager.hasAccess(Permission.VIEW_PROJECT)) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>{{ 'LABEL.PROJECT' | translate }}</mat-expansion-panel-header>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.PROJECT_ADDED' | translate }}</mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onProjectCreated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onProjectCreated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.PROJECT_MODIFIED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onProjectUpdated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onProjectUpdated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.PROJECT_DELETED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onProjectDeleted"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onProjectDeleted.value"></mat-slide-toggle>
                            </div>
                          </mat-expansion-panel>
                        }
                        @if (accessManager.hasAccess(Permission.VIEW_EQUIPMENT)) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>{{ 'LABEL.EQUIPMENT' | translate }}</mat-expansion-panel-header>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.EQUIPMENT_ADDED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onEquipmentCreated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onEquipmentCreated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.EQUIPMENT_MODIFIED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onEquipmentUpdated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onEquipmentUpdated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.EQUIPMENT_DELETED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onEquipmentDeleted"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onEquipmentDeleted.value"></mat-slide-toggle>
                            </div>
                          </mat-expansion-panel>
                        }
                        @if (accessManager.hasAccess(Permission.VIEW_INVESTMENT)) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>{{ 'LABEL.INVESTMENT' | translate }}</mat-expansion-panel-header>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.INVESTMENT_ADDED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onInvestmentCreated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onInvestmentCreated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.INVESTMENT_MODIFIED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onInvestmentUpdated"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onInvestmentUpdated.value"></mat-slide-toggle>
                            </div>
                            <div class="fx-layout-row fx-justify-space-between fx-align-baseline">
                              <mat-label class="fx-flex-20-percent">{{ 'LABEL.INVESTMENT_DELETED' | translate }}
                              </mat-label>
                              <mat-slide-toggle class="fx-flex-20-percent" formControlName="onInvestmentDeleted"
                                                [checked]="reportForm.controls.entitiesHistory.controls.onInvestmentDeleted.value"></mat-slide-toggle>
                            </div>
                          </mat-expansion-panel>
                        }
                      </div>
                    </div>
                    @if (reportForm.controls.noReportDataError.value) {
                      <div class="m-t-15 text-right report-field-container">
                        <span class="text-danger">{{ 'LABEL.REPORT_NO_DATA_ERROR' | translate }}</span>
                      </div>
                    }
                  </section>
                }

                <div
                  class="actions report-field-container m-t-20 m-b-10 fx-layout-row fx-justify-end fx-align-center">
                  <button (click)="onButtonResetClick()" class="m-r-20"
                          mat-stroked-button>{{ 'LABEL.CANCEL' | translate }}
                  </button>
                  <button [disabled]="reportForm.controls.noReportDataError.value || isSaving" (click)="updateUserReport()"
                          mat-raised-button
                          color="accent">{{ 'BUTTON.SAVE' | translate }}
                  </button>
                </div>
              </form>
          </div>
        </div>
        } @else {
          <spinner></spinner>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
